import React, { useState } from 'react';
import {
    Button as AntdButton,
    Card,
    Col,
    DatePicker,
    Divider,
    Dropdown,
    Form,
    Input,
    Row,
} from 'antd';
import { useForm } from 'antd/es/form/Form';
import type { MenuProps } from 'antd';
import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { BiFilterAlt } from "react-icons/bi";
import Button from '../button/component';
import './style.scss';
import Select from '../select/component';

export const FilterComponent = (props: any) => {
    const { columns, onHandleFilter } = props;
    console.log("ccccccccccccc",columns);
    const [filterForm] = useForm();
    const [dropdownCardOpen, setDropdownCardOpen] = useState(false);

    const inputLabelStyle = {
        color: "rgb(50, 56, 66)",
        fontWeight: "600",
    };

    const inputStyle = {
        width: '100%',
        minHeight: '37px',
        paddingLeft: '12px',
        paddingRight: '12px',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: 400,
        background: '#F3F4F6FF',
        borderRadius: '6px',
        borderWidth: '0px',
        outline: 'none'
    };

    const onFinish = async () => {
        const filters = filterForm.getFieldsValue();
        const cleanedFilters = JSON.parse(JSON.stringify(filters));
        await onHandleFilter(cleanedFilters);
        setDropdownCardOpen(false);
    };

    const resetFilter = async () => {
        filterForm.resetFields();
        await onHandleFilter({});
        setDropdownCardOpen(false);
    };

    const items: MenuProps["items"] = [
        {
            key: "1",
            label: (
                <>
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "44px",
                            height: "40px",
                            borderTop: "3px solid #636ae8",
                            borderLeft: "3px solid #636ae8",
                            borderTopLeftRadius: "10px",
                            zIndex: 1,
                        }}
                    />
                    <Card className='dropdown-filter-card'>
                        <Row justify="space-between" align="middle" style={{ marginTop: "-15px" }}>
                            <h3
                                style={{
                                    color: "#0B3E6F",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    marginBottom: "0",
                                }}
                            >
                                <FilterOutlined /> <span style={{ letterSpacing: "0.5px" }}>Filters</span>
                            </h3>
                            <CloseOutlined
                                style={{
                                    cursor: "pointer",
                                    color: "#0B3E6F",
                                    fontSize: "16px",
                                    transition: "color 0.3s",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = "#565E6CFF")}
                                onMouseLeave={(e) => (e.currentTarget.style.color = "#565E6CFF")}
                                onClick={() => setDropdownCardOpen(false)}
                            />
                        </Row>

                        <Divider style={{ margin: "8px -16px 10px -16px", width: '110%' }} />

                        <Form layout="vertical" form={filterForm} onFinish={onFinish}>
                            <div className='filter-card-form'>
                                {columns.map((field: any) => {
                                    if (field?.title && field?.filtertype) {
                                        return (
                                            <Form.Item key={field.title} name={field.dataIndex} label={<span style={inputLabelStyle}>{field.title}</span>}>
                                                {['select', 'multiselect'].includes(field?.filtertype) ? (
                                                    <Select
                                                        showSearch
                                                        options={field?.option || []}
                                                        className="custom-dropdown"
                                                        mode={field?.filtertype === 'multiselect' ? "multiple" : undefined}
                                                        style={inputStyle}
                                                    />
                                                ) : field?.filtertype === 'input' ? (
                                                    <Input style={inputStyle} />
                                                ) : field?.filtertype === 'date' ? <DatePicker style={inputStyle} /> : null}
                                            </Form.Item>
                                        );
                                    }
                                    return null;
                                })}
                            </div>

                            <Divider style={{ margin: "8px -16px 13px -16px", width: '110%' }} />

                            <Row justify="space-between">
                                <Col>
                                    <Button className="filter-btns"
                                        onClick={resetFilter}
                                    >
                                        <span>Reset</span>
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        className="table-add-btns"
                                        htmlType="submit"
                                        onClick={() => onFinish()}
                                    ><span>Apply</span></Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </>
            ),
        },
    ];

    return (
        <div className='filter-container'>
            <Dropdown
                menu={{ items, className: "custom-dropdown-menu" }}
                open={dropdownCardOpen}
                placement="bottomRight"
                overlayStyle={{ padding: 0 }}
            >
                <AntdButton
                    className="filter-btns"
                    onClick={() => setDropdownCardOpen(true)}
                    style={{ background: '#F2F2FD' }}
                >
                    <span style={{ position: 'absolute', left: 5, bottom: 2 }}><BiFilterAlt /></span>
                    <span style={{ paddingLeft: 10 }}> Filter</span>
                </AntdButton>
            </Dropdown>
        </div>
    );
};